import "./photo_block.scss";

export const EncyclopediaPhotoBlock = (props: {
	images: { src: string; name: string }[];
	background?: string;
}) => {
	return (
		<div
			className="photo_block"
			style={{
				backgroundImage: `url(${
					process.env.PUBLIC_URL + props.background
				})`,
			}}
		>
			{props.images.map((image, i) => (
				<div className="wrapper">
					<div className="name">{image.name}</div>
					<img
						key={`${i}-i`}
						src={process.env.PUBLIC_URL + image.src}
						alt=""
					></img>
				</div>
			))}
		</div>
	);
};
